var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SenseCreditWidget',{attrs:{"args":_vm.args,"debug":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }